import React from 'react';
import apiImg from '../../images/info/api_img.png';
function PlayApiIntro() {
    return (
        <div id="introscss">
            <div id="container" className="infoWrap">
                <div className="contentTitle">
                    <div className="titleText">
                        <span className="eng">
                            <span className="colorT">PLAY</span>API
                        </span>
                        <p className="subT">
                            빠르고 쉬운 쇼핑몰 연동을 원하신다면, PLAYAPI가 그 고민을 해결해 드립니다.
                        </p>
                    </div>
                </div>
                <div className="contents">
                    <p className="imgArea">
                        <img src={apiImg} alt="playapi" />
                    </p>
                    <div className="infoDesc">
                        <h3>PLAYAPI 확장성</h3>
                        <ul>
                            <li>
                                <p className="icon icon-api_icon01"></p>
                                다양한 쇼핑몰 연동
                                <p className="infoText">
                                    PLAYAPI는 국내외 주요 쇼핑몰과 연동됩니다. <br />
                                    쇼핑몰추가 시 개발, 유지보수의 부담없이 <br />
                                    서비스에 다양한 쇼핑몰을 연동할 수 있습니다.
                                </p>
                            </li>
                            <li>
                                <p className="icon icon-api_icon02"></p>
                                완성도 높은 서비스
                                <p className="infoText">
                                    상품, 주문, CS관리 등 쇼핑몰과 연동이 필요한
                                    <br />
                                    모든 서비스에 PLAYAPI와의 연동개발 한번으로
                                    <br />
                                    완성도 높은 서비스를 만들 수 있습니다.
                                </p>
                            </li>
                            <li>
                                <p className="icon icon-api_icon03"></p>
                                지속적인 업데이트
                                <p className="infoText">
                                    국내 최대 오픈마켓 판매자를 보유한 PLAYAPI
                                    <br />
                                    서비스는 시시각각 변하는 쇼핑몰의 변경사항을
                                    <br />
                                    빠르고 안정적으로 업데이트 지원합니다.
                                </p>
                            </li>
                        </ul>
                    </div>
                </div>
                <div className="bg-lightGray">
                    <div className="contents">
                        <div className="infoDesc">
                            <h3>손쉬운 개발</h3>
                            <ul>
                                <li>
                                    <p className="icon icon-api_icon04"></p>
                                    제한없는 개발환경
                                    <p className="infoText">
                                        일반적인 웹 사이트 뿐만 아니라 서비스 모든 영역에 <br />
                                        API 연동이 가능하며, 별도의 개발언어의 제한 없이 <br />
                                        손쉽게 서비스를 연동 할 수 있습니다.
                                    </p>
                                </li>
                                <li>
                                    <p className="icon icon-api_icon05"></p>
                                    다양한 API
                                    <p className="infoText">
                                        PLAYAPI 의 다양한 쇼핑몰 연동 기능 중 필요한 <br />
                                        서비스만 선택하여 개발할 수 있습니다.
                                        <br />
                                        이후 모든 기능을 개발해 서비스 확장이 가능합니다.
                                    </p>
                                </li>
                                <li>
                                    <p className="icon icon-api_icon06"></p>
                                    서포트 지원
                                    <p className="infoText">
                                        PLAYAPI 개발 기간 중 전담 서포트 인력매칭으로
                                        <br />
                                        개발에 필요한 사항을 지원하여 빠른 서비스 오픈에
                                        <br />
                                        도움을 드립니다.
                                    </p>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div className="contents">
                    <div className="infoDesc">
                        <h3>믿을 수 있는</h3>
                        <ul>
                            <li>
                                <p className="icon icon-api_icon07"></p>
                                HTTPS 통신구간 암호화
                                <p className="infoText">
                                    개발된 서비스와 PLAYAPI의 모든 통신 구간은
                                    <br /> HTTP-SSL 암호화를 적용하여 안정적으로
                                    <br /> 서비스 할 수 있습니다.
                                </p>
                            </li>
                            <li>
                                <p className="icon icon-api_icon08"></p>
                                24시간 Live 서비스
                                <p className="infoText">
                                    쇼핑몰과의 연동은 24시간 LIVE 지원하고 있어,
                                    <br />
                                    개발된 서비는 별도의 중단없이 365일
                                    <br />
                                    지속적인 서비스가 가능합니다.
                                </p>
                            </li>
                            <li>
                                <p className="icon icon-api_icon09"></p>
                                7천여개 고객사가 선택한
                                <p className="infoText">
                                    PLAYAPI는 16년 동안 안정적 서비스 하고 있으며,
                                    <br />
                                    7천여 고객사가 선택한 플레이오토의 보장된
                                    <br />
                                    기술력을 제공합니다.
                                </p>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default PlayApiIntro;
